<template>
	<div class="cascade-area-container">
		<van-popup
			v-model="show"
			position="bottom"
			@closed='emitResult'>
			<van-area
				title="标题"
				:value="area"
				@confirm='handleConfirm'
				@cancel='handleCancel'
				:area-list="dataItems" />
		</van-popup>
	</div>
</template>

<script>
import areaList from "./data.js";
export default {
    data() {
        return {
            show: false,
            result: []
        };
    },
    computed: {
        dataItems() {
            return this.$store.state.areaDataItems;
        }
    },
    props: [ "area" ],
    mounted() {
        if ( this.dataItems ) {
            this.show = true;
        } else {
            this.getAll();
        }
    },
    methods: {
        emitResult( ) {
            this.$emit( "select", this.result.length > 0 ? this.result : null );
        },
        handleConfirm( result ) {
            this.result = result;
            this.show = false;
        },
        handleCancel() {
            this.show = false;
        },
        getAll() {
            this.getAllAreaItems().then( res => {
                const [ province, city, area ] = res;

                const province_list = {};
                province.data.forEach( v => {
                    province_list[v.provinceCode] = v.provinceName;
                } );
                const city_list = {};
                city.data.forEach( v => {
                    city_list[v.cityCode] = v.cityName;
                } );
                const county_list = {};
                area.data.map( v => {
                    county_list[v.areaCode] = v.areaName;
                } );
                const dataItems = {
                    province_list,
                    city_list,
                    county_list
                };
                this.$store.commit( "setAreaData", dataItems );
                this.show = true;
            } ).catch( console.log );
        },
        getAllAreaItems() {
            return Promise.all( [ this.$apis.getProvinceListRequest(), this.$apis.getCityListRequest(), this.$apis.getAreaListRequest() ] );
        }

    }
};
</script>

<style>

</style>
